export const formattedSubscriberSortOptions = [
    { value: "", text: "Date" },
    { value: "loyalty_DESC", text: "Loyalty" }
];